import { render, staticRenderFns } from "./ModalExcluirContaBloqueada.vue?vue&type=template&id=2684de02&scoped=true"
import script from "./ModalExcluirContaBloqueada.vue?vue&type=script&lang=js"
export * from "./ModalExcluirContaBloqueada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684de02",
  null
  
)

export default component.exports